export const NO_VALUE_FALLBACK = "undefined";
export const INIT_MESSAGE = "Initializing Dash0 Web SDK";
